module.exports = __webpack_public_path__ + "src/assets/fonts/MCoTzAn-1s3IGyJMVacY3w.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/MCoTzAn-1s3IGyJMVacY3w.woff2
// module id = 127
// module chunks = 0